<template>
  <section class="hero text-center text-white">
    <b-container>
      <b-row>

        <b-col lg="8" offset-lg="2" class="text-center">
          <h1>
            <span>WHIN</span>
            <img src="@/assets/logos/whin-text.svg" class="mastheadLogo" alt="WHIN"/>
          </h1>
          <p>
            The Wabash Heartland Innovation Network is a consortium of 10 counties in
            north-central Indiana devoted to working together to fuel prosperity by
            harnessing the power of Internet-enabled sensors to develop our region into
            a global epicenter of digital agricultural and next-generation manufacturing.
          </p>
          <br>
          <br>

          <form id="newsletterForm" class="text-left" style="">
            <p>Sign up for monthly newsletter</p>
            <div class="row">
              <div class="col col-9">
                <p>
                  <input placeholder="email" id="newsletterEmail" type="email" name="email" class="form-control"
                         style="opacity: .65; background-color: white; border-color: white; border-radius: 5px; min-width: 10rem; "/>
                </p>
              </div>
              <div class="col col-3">
                <button type="submit" class="btn btn-primary"
                        style='color: white; border-color: transparent; background-color: transparent; font-size: 1.1rem; padding: .5rem;'>
                  SUBMIT
                </button>
              </div>

            </div>
          </form>

        </b-col>
      </b-row>
    </b-container>
    <div class="attribution">
      <span>Photo courtesy of the Indiana Department of Natural Resources</span>
    </div>
    <canvas class="network" id="foregroundNetwork"></canvas>

  </section>
</template>
<script>
export default {
  name: 'home-hero-section'
}
</script>
<style scoped>
.hero {
  background-position: top center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: relative;
}

.hero {
  background-image: url("../assets/img/backgrounds/river.jpg");
  padding: 10rem 0 17rem 0;
}

.hero h1 span {
  display: none;
}

.hero h1 img {
  margin-bottom: 0.5rem;
  width: 100%;
}

.hero p {
  font-size: 1rem;
  line-height: 1.2;
  text-align: justify;
}

.hero #reportLink img {
  box-shadow: 0 6px 12px rgba(32, 32, 32, 0.67);
  display: block;
  margin: 0 auto 20px auto;
  max-width: 70%;
}

.hero #reportLink span {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid #fff;
  border-radius: 15px;
  color: #fff;
  display: inline-block;
  margin-bottom: 10px;
  padding: 5px 15px;
  text-align: center;
  transition: background 0.25s;
}

.hero #reportLink:hover span {
  background: rgba(255, 255, 255, 1);
  color: #666;
  transition: background 0.25s;
}

@media (min-width: 768px) {
}

@media (min-width: 992px) {
  .hero {
    height: 88vh;
    min-height: 650px;
  }
}

@media (max-width: 992px) {
  .hero {
    padding-bottom: 0;
  }

  .hero #reportLink img {
    max-width: 40%;
  }

  .hero h1 {
    margin-top: 3rem;
    padding: 0 2rem;
  }

  .hero p {
    padding: 0 2rem;
  }
}

.attribution {
  color: #fff;
  font-size: 0.75rem;
  opacity: 0.667;
  position: absolute;
  bottom: 0.5rem;
  right: 1rem;
}

</style>